// ==================== ENUMS ===================

import type { Maybe } from '@adornis/base/utilTypes.js';
import { registerEnum } from '@adornis/baseql/metadata/register.js';

/** [Daniel-Todo] outsource following enums to different file */
export enum TaskState {
  Pending = 'Pending',
  Finished = 'Finished',
  Reoccuring = 'Reoccuring',
}

export enum StudentType {
  OS = 'Oberstufe',
  US = 'Unterstufe',
}

export enum Weekday {
  MONDAY = 'Montag',
  TUESDAY = 'Dienstag',
  WEDNESDAY = 'Mittwoch',
  THURSDAY = 'Donnerstag',
  FRIDAY = 'Freitag',
  SATURDAY = 'Samstag',
  SUNDAY = 'Sonntag',
}

export enum Workday {
  MONDAY = Weekday.MONDAY,
  TUESDAY = Weekday.TUESDAY,
  WEDNESDAY = Weekday.WEDNESDAY,
  THURSDAY = Weekday.THURSDAY,
  FRIDAY = Weekday.FRIDAY,
}

export function weekdayIndex(weekday: Maybe<Weekday>): number {
  if (!weekday) return -1;
  return Object.values(Weekday).indexOf(weekday);
}

export enum SchoolSubject {
  MATHE = 'Mathe',
  DEUTSCH = 'Deutsch',
  ENGLISCH = 'Englisch',
}

export enum Subject {
  DEUTSCH = 'Deutsch',
  MATHE = 'Mathe',
  ENGLISH = 'Englisch',
  DAZ = 'Deutsch Basic-Kurs (DaZ) ',
  FRANZOESISCH = 'Französisch ',
  SPANISCH = 'Spanisch',
  LATEIN = 'Latein',

  // These for student formular
  CHEMIE = 'Chemie',
  BIOLOGIE = 'Biologie',
  PHYSIK = 'Physik',

  // This for courses. Why? I dont fucking know
  NATURWISSENSCHAFTEN = 'Naturwissenschaften',
}

export enum IntensiveCourseSubject {
  DEUTSCH = Subject.DEUTSCH,
  MATHE = Subject.MATHE,
  ENGLISH = Subject.ENGLISH,
  FRANZOESISCH = Subject.FRANZOESISCH,
}

export enum ExamPreparationSubject {
  DEUTSCH = Subject.DEUTSCH,
  MATHE = Subject.MATHE,
  ENGLISH = Subject.ENGLISH,
}

export enum Gender {
  MALE = 'männlich',
  FEMALE = 'weiblich',
  DIVERSE = 'divers',
}

export enum WithdrawalType {
  EMAIL = 'E-Mail',
  MAIL = 'Brief',
  PHONE = 'Telefonisch',
  VOCAL = 'Mündlich in Schule',
  HOMEPAGE = 'Kontaktformular Homepage',
  OTHER = 'Sonstiges',
  MESSENGER = 'Messenger',
}

export enum WithdrawalFrom {
  ELTERN = 'Eltern',
  CHANCENWERK = 'Chancenwerk',
  STUDENT = 'Schüler',
  SCHULE = 'Schule',
  SCHUKO = 'Mitteilung von PL, STB oder Schuko',
  SONSTIGES = 'Sonstiges',
}

export enum WithdrawalReason {
  ANBIETER_WECHSEL = 'Anbieterwechsel',
  KEIN_FOERDERBEDARF_MEHR = 'Kein Förderbedarf mehr/Notenverbesserung',
  KEINE_LUST = 'Kind hat keine Lust mehr',
  SELBSTSTAENDIG = 'Kind lernt nun selbstständig',
  SCHULWECHSEL = 'Schulwechsel',
  UNZUFRIEDEN_QUALITAET = 'Unzufriedenheit mit Qualität',
  ZU_HOHE_ZEITLICHE_BELASTUNG = 'Zu hohe zeitliche Belastung',
  ZU_TEUER = 'Zu hohe Kosten',
  KEINE_ANGABE = 'Keine Angabe',
  IN_KLAERUNG = 'In Klärung',
  KOOPERATIONSENDE = 'Kooperationsende',
  LERNFOERDERUNG_AUSGESCHLOSSEN = 'Kind wurde von Lernförderung ausgeschlossen',
  ELTERN_ANDERE_VORSTELLUNG = 'Eltern hatten andere Vorstellung',
  DATENBANKBEREINIGUNG = 'Datenbankbereinigung',
  SONSTIGES = 'Sonstiges',
  ZEITEN_PASSEN_NICHT = 'Zeiten passen nicht',
  SCHULE_ABGESCHLOSSEN = 'Schule abgeschlossen',
}

export enum PaymentMethod {
  WARTELISTE = 'Warteliste',
  LASTSCHRIFT = 'Lastschrift',
  BUT = 'BuT',
  BILDUNGSGUTSCHEIN = 'Bildungsgutschein',
  SELBSTZAHLER = 'Selbstzahler',
  SPENDENEINZUG = 'Spendeneinzug',
  ZAHLUNGAUSGESETZT = 'Zahlung ausgesetzt',
  STIPENDIUM = 'Stipendium',
  DIGITAL_NOT_FINISHED = 'digital angemeldet, Unterlagen noch unvollständig',
}

export enum Teilleistungsschaechen {
  LRS = 'Schwierigkeiten im Lesen und Schreiben',
  KONZENTRATIONSSCHWAECHE = 'Schwierigkeiten, sich zu konzentrieren',
  ADS = 'ADS/ADHS',
}

export enum Mitgliedschaften {
  HILFE_GEBEN_NEHMEN = 'Hilfe geben - Hilfe nehmen',
  HILFE_NEHMEN = 'Hilfe nehmen',
  HILFE_GEBEN = 'Hilfe geben',
}

export enum Registermethode {
  FORM = 'Formular',
  MANUALLY = 'Manuell über Mitarbeiter',
  TOKEN = 'Zugangs-Code',
  GUEST = 'Board Gast-Account',
  OS = 'OS-Akquise',
  HEFTE = 'Über Hefte-Lehrer',
}

// We have some students (e.g. from CHANCENschule) with 75€ or 150€, so we use this list in the student page
export const Mitgliedsbeitrag = [0, 10, 15, 20, 25, 30, 40, 50, 60, 75, 120, 135, 150];

// Standard membership fees for KPFs
export const KPFStandardMembershipFeeOptions = [0, 10, 20, 25, 30, 40, 50, 60, 85];

export enum Aufenthalt {
  PRAESENZ = 'Präsenz',
  DIGITAL = 'Digital',
  DIGITAL_PRAESENZ = 'Digital + Präsenz',
}

export enum StudentAvailableDay {
  FIRST_DAY = '1. Tag',
  SECOND_DAY = '2. Tag',
  BOTH_DAYS = 'Beide Tage',
}

export enum BuTStatus {
  IN_PLANUNG = 'in Planung',
  PRIO_1 = 'Prio1',
  PRIO_2 = 'Prio2',
  KEIN_BUT = 'kein BuT',
}

export enum Cities {}

export enum Bundesland {
  BADENWUERTTEMBERG = 'Baden-Württemberg',
  BAYERN = 'Bayern',
  BERLIN = 'Berlin',
  BRANDENBURG = 'Brandenburg',
  BREMEN = 'Bremen',
  HAMBURG = 'Hamburg',
  HESSEN = 'Hessen',
  MECKLENBURGVORPOMMERN = 'Mecklenburg-Vorpommern',
  NIEDERSACHSEN = 'Niedersachsen',
  NORDRHEINWESTFALEN = 'Nordrhein-Westfalen',
  RHEINLANDPFALZ = 'Rheinland-Pfalz',
  SAARLAND = 'Saarland',
  SACHSEN = 'Sachsen',
  SACHENANHALT = 'Sachen-Anhalt',
  SCHLESWIGHOLSTEIN = 'Schleswig-Holstein',
  THUERINGEN = 'Thüringen',
}

//* The Legacy types are not used anymore, but we need to keep them to track answer eventlogs from already removed exercise types
export enum ExerciseType {
  H5P = 0,
  FREITEXT = 1,
  FORMEL = 2, // Legacy
  GEOGEBRA = 3,
  MEDIA = 4, // Legacy
  LEVUMIGERMAN = 5,
  LEVUMIMATH = 6,
  SERLO = 7,
  CHEMISTRY_FORMULA = 8,
  LEVUMI_NUMBER_DICTATE = 9,
  SERLO_EDITOR = 10,
}

export enum GroupType {
  STUDENTS = 0,
  EMPLOYEES = 1,
}

export enum ContactMethod {
  LETTER = 'Brief',
  MOBILE = 'Handy',
  LANDLINE = 'Festnetz',
  EMAIL = 'E-Mail',
  MESSENGER = 'Messenger',
  WHATSAPP = 'WhatsApp',
}

export enum ContactPersonType {
  SCHUKO = 'SchuKo',
  PARENT = 'Erziehungsberechtigte:r',
  FAMILY = 'Angehörige:r',
  SCHOOL = 'Schule',
  DEPARTMENT = 'Amt',
}

export enum LogicExpression {
  AND = 'AND',
  OR = 'OR',
}

registerEnum({ name: 'LogicExpression', enum: LogicExpression });
